// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"144": "d2ea0b29","264": "ae4bcedf","282": "d3dd6ae3","31": "600d0a29","354": "947f30a9","466": "4b3f689d","535": "c7723ad3","56": "3359890e","625": "73ce1db0","640": "dc859832","689": "ddceee07","787": "d3c925a7","878": "b774d1d2","970": "ef38543d",}[chunkId] + ".js"
}